import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { isBool } from '@@client/lib/util';
import { classnames } from '@@client/lib/classes';
import { getPartSummary, checkIsNew } from '@@client/parts/parts-helper';
import Img from '@@client/components/Img';
export default function PartPhoto(_ref) {
  var partInfo = _ref.partInfo,
      src = _ref.src,
      alt = _ref.alt,
      onLoad = _ref.onLoad,
      className = _ref.className,
      _ref$fillContainer = _ref.fillContainer,
      fillContainer = _ref$fillContainer === void 0 ? true : _ref$fillContainer,
      _ref$isNew = _ref.isNew,
      isNew = _ref$isNew === void 0 ? null : _ref$isNew;
  alt = alt || getPartSummary(partInfo);
  isNew = isBool(isNew) ? isNew : checkIsNew(partInfo.inventoriedDate);
  var photoClassNames = classnames([className, 'photo', 'c--photo-flag', isNew ? 'm--flag-new' : null, fillContainer ? 'fill-container' : null]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-1934147058" + " " + (photoClassNames || ""),
      children: /*#__PURE__*/_jsx(Img, {
        src: src,
        alt: alt,
        onLoad: onLoad
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1934147058",
      children: [".photo.jsx-1934147058 img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;}", ".photo.fill-container.jsx-1934147058{width:100%;height:100%;}"]
    })]
  });
}